const Config = {
    genAIEnabled: (process.env.REACT_APP_GEN_AI_ENABLED || "true").toLowerCase() === "true",
    matomoURL: process.env.REACT_APP_MATOMO_URL || "https://dev-trk.testmaya.com/",
    matomoSiteID: Number(process.env.REACT_APP_MATOMO_SITE_ID) || 9
};

export default Config